import { useEffect } from 'react';
import { z } from 'zod';
import { setZodErrorMap } from '@autopia/api-contracts';

import { ErrorBoundary } from './app/ErrorBoundary';
import { KioskShell } from './app/KioskShell';
import { AppRoutes } from './app/router';
import { makeZodErrorMap } from './i18n/zod-i18n';
import { useKioskStore } from './store/kioskStore';

export function App(): JSX.Element {
  const language = useKioskStore((s) => s.language);

  // Install the locale-aware Zod error map on BOTH zod instances whenever the
  // language changes (mirrors apps/admin providers/index.tsx). `z.setErrorMap`
  // covers app-built schemas; `setZodErrorMap` reaches the api-contracts CJS
  // instance so schemas fed straight into zodResolver localize too.
  useEffect(() => {
    const errorMap = makeZodErrorMap(language);
    z.setErrorMap(errorMap);
    setZodErrorMap(errorMap);
  }, [language]);

  return (
    <ErrorBoundary>
      <KioskShell>
        <AppRoutes />
      </KioskShell>
    </ErrorBoundary>
  );
}
